import './Home.css'

import a from "/Users/nikkylu/lumed/src/pages/components/gauze/a.jpg";
import b from "/Users/nikkylu/lumed/src/pages/components/gauze/b.jpg";
import c from "/Users/nikkylu/lumed/src/pages/components/gauze/c.jpg";
// import d from "/Users/nikkylu/lumed/src/pages/components/gauze/d.jpg";
import e from "/Users/nikkylu/lumed/src/pages/components/gauze/e.jpg";
import f from "/Users/nikkylu/lumed/src/pages/components/gauze/f.jpg";
import g from "/Users/nikkylu/lumed/src/pages/components/gauze/g.jpg";
import h from "/Users/nikkylu/lumed/src/pages/components/gauze/h.jpg";
import i from "/Users/nikkylu/lumed/src/pages/components/gauze/i.jpg";
import j from "/Users/nikkylu/lumed/src/pages/components/gauze/j.jpg";
import k from "/Users/nikkylu/lumed/src/pages/components/gauze/k.jpg";
import l from "/Users/nikkylu/lumed/src/pages/components/gauze/l.jpg";
import m from "/Users/nikkylu/lumed/src/pages/components/gauze/m.jpg";
import n from "/Users/nikkylu/lumed/src/pages/components/gauze/n.jpg";


const Tape = () => {


  return (
    <div className="Home">
        <div>Cotton & Gauze</div>

<div className="Home-con">
    <img src={a} className="Home-sp"/>
    <div className="Home-s">
        <div>Cotton Absorbent Gauze, BP/USP/HQ, CE</div>
        <div>40’s x 40’s, 12x8 / 15x10 / 18x14(13 threads/cm2) / 25x17(17 threads/cm2) mesh, etc.</div>
        <div>in rolls of 36” x 50yds/100yds/100m, 4-ply; or in jumbo rolls of 120cm x 2000m, 1-ply, or in zigzag folded of 80cm x 100m, etc.</div>
    </div>
</div>

<div className="Home-con">
    <img src={b} className="Home-sp"/>
    <div className="Home-s">
        <div>Cotton Absorbent Gauze Swabs/Sponges, BP/USP/HQ, CE</div>
        <div>non-sterile/sterile, white/green, with/without x-ray detectable threads, various sizes</div>
    </div>
</div>

<div className="Home-con">
    <img src={c} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Cotton Balls, BP/USP/HQ, CE</div>
        <div>non-sterile/sterile, white, with/without x-ray detectable threads, various sizes</div>
    </div>
</div>

<div className="Home-con">
    <img src={e} className="Home-sp"/>
    <div className="Home-s">
        <div>Laparatomy Sponges, BP/USP/HQ, CE</div>
        <div>prewashed / non-prewashed, white, non-sterile/sterile, with/without x-ray detectable tapes/threads, with/without cotton loops, various sizes</div>
    </div>
</div>

<div className="Home-con">
    <img src={f} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Gauze Bandages, BP/USP/HQ, CE</div>
        <div>white open wow or self-edged, various sizes</div>
    </div>
</div>

<div className="Home-con">
    <img src={g} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Cotton Wool, BP/HQ, CE</div>
        <div>in rolls of 100g, 250g, 500g, 1000g</div>
    </div>
</div>

<div className="Home-con">
    <img src={h} className="Home-sp"/>
    <div className="Home-s">
        <div>Zigzag Absorbent Cotton Wool, BP/HQ</div>
        <div>50g, 100g, 250g, 500g per pack</div>
    </div>
</div>

<div className="Home-con">
    <img src={i} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Cotton Orthopaedic Paddings, BP/HQ</div>
        <div>100% cotton, or 50% viscose+50% polyester, or 100% viscose, size: 5cm/7.5cm/10cm/15cm x 2.7m/3m/4.5m</div>
    </div>
</div>

<div className="Home-con">
    <img src={j} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Cotton Pads</div>
        <div>in shapes of quadrate, circle, oval, etc., various sizes</div>
    </div>
</div>

<div className="Home-con">
    <img src={k} className="Home-sp"/>
    <img src={l} className="Home-sp"/>
    <img src={m} className="Home-sp"/>
    <img src={n} className="Home-sp"/>
    <div className="Home-s">
        <div>Absorbent Cotton Buds</div>
        <div>with wooden applicator or with plastic applicator, various sizes</div>
    </div>
</div>


        
    </div>
  )
}

export default Tape;